// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"449":"0537fc32668a8d5c","3687":"e9a4a3ddcb60bd5b","7667":"3bbca4af29013c70","7874":"55ae609a30c75291","9950":"a0512d2bec7a4aed"}[chunkId] + ".js";
};